module.exports = __webpack_public_path__ + "img/bemisia-tabaci.749aeb87.jpg";